import { Typography } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;

  .ant-empty {
    margin: 56px 8px;
  }

  .ant-collapse-header {
    border-radius: 4px;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const ItemDescriptionWrapper = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
